import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { Dependencies, ReduxStore, RootState } from "./store.types"
import { listenerMiddleware } from "./store.listener"
import { etlData } from "../slices/etlData/slice/etlData.slice"
import { formStep } from "../slices/formStep/slice/formStep.slice"
import { auth } from "../slices/auth/slice/auth.slice"
import { navigation } from "../slices/navigation/slice/navigation.slice"
import { apiSlice } from "./rtk-instance";

import * as Sentry from "@sentry/react"

export const initStore = (dependencies?: Dependencies, preloadedState?: Partial<RootState>): ReduxStore => {
	const sentryReduxEnhancer = Sentry.createReduxEnhancer({
		dsn: import.meta.env.VITE_SENTRY_DSN,
	})

	return configureStore({
		reducer: combineReducers({
			etlData,
			formStep,
			auth,
			navigation,
			etlApi: apiSlice.reducer,
		}),
		preloadedState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				thunk: {
					extraArgument: dependencies,
				},
				serializableCheck: {
					ignoredPaths: [],
				},
			}).prepend(listenerMiddleware.middleware).concat(apiSlice.middleware),
		enhancers: (getDefaultEnhancers) => {
			return getDefaultEnhancers().concat(sentryReduxEnhancer)
		},
		devTools: true,
	})
}
